<template>
<main class="registration-container fullmakt-compilation">
  <div class="registration">
    <Logo />

    <h1 class="registration__title">Skapa ett konto</h1>
    <p>För att vi ska kunna ta del av pensionsrelevant information om dig från olika aktörer behöver du skriva på en fullmakt. Fullmaktskollen är en extern tjänst framtagen i samarbete med Pensionsmyndigheten.</p>

    <section class="registration__middle">
      <h2 class="registration__subtitle">Signera din fullmakt</h2>

      <div class="registration__content-container">
        <div>
          <FullmaktTimeSelector :validTo.sync="date" v-if="user.fullmakt.status != 'Unsigned'"  />
          <Button
            v-if="user.status == 'loaded' && user.fullmakt.status != 'Unsigned'"
            msg="Fortsätt"
            @click.native="updateUser"
            class="button--primary button--center"
          />

          <span v-if="user.fullmakt.status == 'Unsigned'">Du har en osignerad fullmakt, var snäll och signera det</span>

          <LoadingSpinner v-if="user.status == 'uploading'" />

          <p class="fullmakt__link-container">
            Gå till <a class="fullmakt__link link link--green" href="https://www.fullmaktskollen.se/" target="_blank">www.fullmaktkollen.com</a> för att signera.
          </p>
        </div>
      </div>
    </section>

    <!-- <RegistrationFooter /> -->
  </div>
</main>
</template>

<script>
import Button from '../components/elements/Button';
import FullmaktTimeSelector from '../components/elements/FullmaktTimeSelector';
import RegistrationFooter from '../components/elements/RegistrationFooter';
import LoadingSpinner from '../components/elements/LoadingSpinner';
import Logo from '../components/elements/Logo';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Fullmakt',
  data () {
    return {
        date: null,
    }
  },
  components: { Button, LoadingSpinner, FullmaktTimeSelector, Logo, RegistrationFooter },
  computed: {
    ...mapGetters([ 'user' ]),
  },
  methods: {
    ...mapActions([ 'createFullmakt' ]),
    updateUser () {
      this.createFullmakt(this.date).then((res) => {
        if (res) {
          this.$router.push('/')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fullmakt__link-container {
  text-align: center;
  margin-top: 1rem !important;
}

.fullmakt__link {
  margin-right: 3px;
}
</style>